import { render, staticRenderFns } from "./SupportInfo.vue?vue&type=template&id=6866204c&scoped=true"
import script from "./SupportInfo.vue?vue&type=script&lang=js"
export * from "./SupportInfo.vue?vue&type=script&lang=js"
import style0 from "./SupportInfo.vue?vue&type=style&index=0&id=6866204c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6866204c",
  null
  
)

export default component.exports